import { styled } from "../gatsby-theme-stitches/config"
import { Link as GatsbyLink } from "gatsby"
import React, { FC, ReactNode } from "react"
import { CSSProperties } from "@stitches/react"

const StyledNavLink = styled(GatsbyLink, {
  textDecoration: "underline",
  cursor: "pointer",
  color: "$link",
})

const StyledExternalLink = styled("a", {
  textDecoration: "underline",
  cursor: "pointer",
  color: "$link",
})

export const Link: FC<
  { to: string; css?: any; partiallyActive?: boolean } & { children: ReactNode }
> = ({ children, to, css, partiallyActive, ...props }) => {
  return to.includes("https") || to.includes("mailto:") ? (
    <StyledExternalLink {...props} href={to} css={css}>
      {children}
    </StyledExternalLink>
  ) : (
    <StyledNavLink
      {...props}
      to={to}
      activeClassName="active"
      partiallyActive={partiallyActive}
      css={css}
    >
      {children}
    </StyledNavLink>
  )
}
